import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardImg, CardBody, CardTitle, CardSubtitle } from 'reactstrap';
import { Badge, Button } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiCogTransferOutline } from '@mdi/js';
import printerImage from '../../assets/images/printer.png';
import cardPrinterImage from '../../assets/images/printer_card.png';

import './PrinterResume.css';

const PrinterResume = ({ printer, className, hideHost, hideDetails, ...rest }) => {
    const { t } = useTranslation();
    const connected = printer.isConnected();

    return (
        <div className={ `PrinterResume ${className}` } { ...rest }>
            <Card className="card-outline">
                <CardHeader>
                    <CardTitle tag="h6" title={printer.name}>
                        { printer.name?.substring(0, 16) }{ !hideHost ? '@' + printer.host : '' }
                        { hideDetails && (
                        <Button tag={ Link } to={`/devices/printers/manage/${printer._id}`} color={ 'link' }>
                            <Icon path={ mdiCogTransferOutline } color="white" size={ 1 } />
                        </Button>
                        )}
                    </CardTitle>
                </CardHeader>
                <CardImg
                    top
                    width="100%"
                    src={ printer.isCardPrinter() ? cardPrinterImage : printerImage }
                    alt="Printer image cap"
                    className={ connected ? 'connected' : 'disconnected' }
                />
                { !hideDetails && (
                <CardBody>
                    <CardSubtitle tag="h6" className="mb-2 text-muted">
                        <Badge color={ connected ? 'success' : 'danger' }>
                            { t(`printers.${connected ? 'connected' : 'disconnected'}`) }<br/>
                        </Badge>
                    </CardSubtitle>
                    <Button tag={ Link } to={`/devices/printers/manage/${printer.id}`} color={ 'info' } block>
                        <Icon path={ mdiCogTransferOutline } color="white" size={ 1 } />
                        { t('printers.manage') }
                    </Button>
                </CardBody>
                )}
            </Card>
        </div>
    );
}

export default PrinterResume;
